import { render, staticRenderFns } from "./BaseSelectButton.vue?vue&type=template&id=3548e827&scoped=true"
import script from "./BaseSelectButton.vue?vue&type=script&lang=js"
export * from "./BaseSelectButton.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectButton.vue?vue&type=style&index=0&id=3548e827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548e827",
  null
  
)

export default component.exports